import { Search, X } from "lucide-react";
type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export function SearchInput({
  value,
  onChange,
  placeholder = "Search...",
}: SearchInputProps) {
  return (
    <div className="relative w-full mb-3">
      <Search
        size={18}
        className="text-secondary absolute top-1/2 left-3 -translate-y-1/2"
      />

      <input
        type="text"
        value={value}
        onChange={(e) => { onChange(e.target.value); }}
        placeholder={placeholder}
        className="h-10 w-full rounded-full border border-input-border bg-input pr-10 pl-10 text-sm text-body outline-none transition placeholder:text-input-placeholder focus:border-transparent focus:ring-2 focus:ring-primary/20"
      />

      {value && (
        <button
          type="button"
          onClick={() => {onChange(""); }}
          className="absolute top-1/2 right-3 -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}